// extracted by mini-css-extract-plugin
export default {"date":"styles_date__kTmSA","title":"styles_title__E9JBM","selected":"styles_selected__nnaHj"};